import React from "react";
import "./SummaryHeader.scss";

const SummaryHeaderComponent = () => (
  <h2 className="summary__header">Resumen</h2>
);

export default SummaryHeaderComponent;
